import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {mintEntityId} from "../utils/uid.utils";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";
import {freeCellNearParent} from "../utils/techTree.utils";

export class AddTechNodeCommand extends CommandBase {
    parent: string;
    name: string;

    constructor(parent: string, name: string = 'New Tech') {
        super();
        this.parent = parent;
        this.name = name;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.techTree.findIndex(u => u.id === this.parent);
        if (index < 0) {
            return false;
        }

        const id = mintEntityId('tech', this.name, data.techTree.map(n => n.id));
        // Place the new node next to its parent when the parent itself is
        // placed, so it doesn't appear somewhere unrelated. If the parent has no
        // authored position the child is left unplaced too and both keep using
        // the Tech Tree tab's computed layout.
        const cell = freeCellNearParent(data.techTree, this.parent);
        data.techTree.push({
            id: id,
            price: 5,
            children: [],
            unlocks: [],
            ...(cell ? {x: cell.x, y: cell.y} : {})
        });

        data.techTree[index].children.push(id);
        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new ChangeLocalizationValuesCommand(`${id}.description`, 'Default Tech Description').execute(data);

        return true;
    }
}